import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["pdf-viewer"]

  connect() {
    this.activeVizId = null
  }

  toggleVisualization(event) {
    const { vizId, page, url, boundingBox } = event.params
    const isActive = this.activeVizId === vizId

    if (this.activeVizId) this.deactivateVisualization(this.activeVizId)

    if (isActive) {
      this.activeVizId = null
    } else {
      if (this.hasPdfViewerOutlet) this.pdfViewerOutlet.showOverlay(vizId, page, { url, boundingBox })
      this.updateButtonState(vizId, true)
      this.activeVizId = vizId
    }
  }

  deactivateVisualization(vizId) {
    this.updateButtonState(vizId, false)
    if (this.hasPdfViewerOutlet) this.pdfViewerOutlet.hideOverlay(vizId)
  }

  updateButtonState(vizId, active) {
    const button = this.element.querySelector(`button[data-document-viewer-viz-id-param="${vizId}"]`)
    if (button) {
      if (active) {
        button.classList.remove("text-content", "border-border")
        button.classList.add("bg-content-strong", "text-surface", "border-content-strong")
      } else {
        button.classList.remove("bg-content-strong", "text-surface", "border-content-strong")
        button.classList.add("text-content", "border-border")
      }
    }
  }
}
